import { Component } from '@angular/core';

@Component({
  selector: 'app-support-embed',
  templateUrl: 'embed.component.html',
  styleUrls: [],
})
export class SupportEmbedComponent {}
